// extracted by mini-css-extract-plugin
export default {"activateCtn":"Activate_activateCtn__VYwcR","cardCtn":"Activate_cardCtn__Lshyk"};